import { stringify } from 'query-string'
import selectedOrgId from '../../utils/helpers/selectedOrgId'
import axiosInstance from '../../Apis/axiosInterceptor/axiosInstance'

const playerProvider = {
  getList: (resource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort

    let queryParams = {}
    Object.entries(params.filter).forEach((filter) => {
      const [key, value] = filter
      queryParams = { ...queryParams, [key]: value }
    })
    queryParams = {
      ...queryParams,
      page,
      perPage,
      OrderBy: order === 'ASC' ? field : `-${field}`,
      // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1])
    }

    const url = `v1/orgs/${selectedOrgId()}/${resource}?${stringify(queryParams)}`

    return axiosInstance.get(url).then(({data}) => ({
      data: data.players,
      total: data.metadata.totalCount,
    }))
  },

  create: (resource, params) => {
    // `teams` is no longer accepted by the backend (PlayerForCreationDto.Teams was dropped)
    const { logo, teams, ...rest } = params.data
    const payload = { ...rest, logoDataUri: logo }
    return axiosInstance.post(`v1/orgs/${selectedOrgId()}/${resource}`, payload).then(({ data }) => ({
      data: {
        ...data,
        contacts: [{ type: 'EMAIL' }, { type: 'PHONE_NUMBER' }],
        positions: data.personalData?.positions?.map((position) => position.id),
      },
    }))
  },

  getOne: (resource, params) =>
    axiosInstance.get(`v1/orgs/${selectedOrgId()}/${resource}/${params.id}`).then(({ data }) => ({
      data: data,
    })),

  delete: (resource, params) =>
    axiosInstance.delete(`v1/orgs/${selectedOrgId()}/${resource}/${params.id}`).then(() => ({ data: {} })),

  update: (resource, params) => {
    // `teams` is no longer accepted by the backend (PlayerForUpdateDto.Teams was dropped)
    const { teams, ...rest } = params.data
    return axiosInstance
      .patch(`v1/orgs/${selectedOrgId()}/${resource}/${params.id}`, rest)
      .then(({ data }) => ({ data: data }))
  },
}

export default playerProvider
